<template>
    <v-layout row wrap class="land-full-flex grey lighten-4">
      <!-- LEFT -->
      <v-flex row wrap id="outer-left" :class="myclass" text-md-right xs12 sm4>
        <Left/>
      </v-flex>

      <!-- RIGHT -->
      <v-flex id="outer-right" :class="myclass" text-md-left xs12 sm8>
        <Right/>
      </v-flex>
    </v-layout>
</template>

<script>
  import Left from './Left';
  import Right from './Right';
  export default {
    components: {Left, Right},
    data(){
      return{
        myclass:{
          'center':true,
          'myheight': this.$vuetify.breakpoint.smAndDown
        }
      }
    },
    mounted(){
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .land-full-flex {
    height: 100vh;
    width: 100%;
    min-width: 100%;
    padding: 0;
    margin: 0;
  }

  #outer-right {
    display: flex;
    justify-content: center; /* align horizontal */
    align-items: center; /* align vertical */
  }

  #outer-left{
    display: flex;
    justify-content: center; /* align horizontal */
    /*align-items: center; !* align vertical *!*/
  }
</style>



// WEBPACK FOOTER //
// src/components/desktop/home/Landing.vue